var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPlayBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:play-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1937 10.1325C23.7141 10.4092 24.1493 10.8222 24.4528 11.3274C24.7563 11.8325 24.9166 12.4107 24.9166 13C24.9166 13.5894 24.7563 14.1676 24.4528 14.6727C24.1493 15.1779 23.7141 15.5909 23.1937 15.8676L9.31407 23.4152C7.07915 24.6318 4.33398 23.0501 4.33398 20.5487V5.45247C4.33398 2.94997 7.07915 1.36938 9.31407 2.5838L23.1937 10.1325Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPlayBold);
export default __webpack_public_path__ + "static/media/solar_play-bold.1edf70c89f09f4a78dca17e5f378b715.svg";
export { ForwardRef as ReactComponent };